import React, { FC } from 'react'
import _ from 'lodash'
// Data
import { parseDate } from "data/lib/dates"
import { localizeNum, isValidNumber, getNumForDisplay } from "data/lib/numbers"
import propertyService from 'data/property'
// Styles
import { Label_s } from 'styles/app-styles'
import { LineItemDetailed_s, LineItemDetailedHover_s } from 'components/table/hovers/hover-styles'

type LineItemDetailedProps = {
  config: {},
  data: [],
  areaMeasureData: object[],
  inflationData: object[],
  lineItemData: object[],
  state: string
}

const LineItemDetailedHover: FC<LineItemDetailedProps> = (props) => {
  const state = props.state === 'detailed' ? 'lineItemDetailed' : props.state
  let items   = props.data['lineitemdetail']?.items || props.data['adrdetail']?.items || props.data['occupancydetail']?.items || [];
  let count   = items.length;
  if (count > 3) items = items.slice(0, 3);

  function getYearHeader(year:number):JSX.Element {
    const currentProperty   = propertyService.get()
    const analysisBeginDate = parseDate(_.get(currentProperty, 'analysisbegindate'));
    const currentMonth      = analysisBeginDate.month();
    const currentYear       = analysisBeginDate.year();
    const diff              = year - 1;
    const yearHeader        = currentMonth === 0 ? <Label_s>{currentYear + diff}</Label_s> : <Label_s>{`${currentYear + diff}-${currentYear + diff + 1}`}</Label_s>
    return yearHeader

  }

  const codeFor = (val) => _.get(val, 'code')

  return (
    <LineItemDetailedHover_s>
      <div>
        { props.data['lineitemdetail']?.['lineItemId'] && <div>
          <Label_s>{ props.config[state].single[0].label }</Label_s>: <span>{ codeFor(_.find(props.lineItemData, { lineitemid: props.data['lineitemdetail']['lineItemId']  })) }</span>
        </div> }
        { props.data['lineitemdetail']?.inflation && <div>
          <Label_s>{ props.config[state].single[0].label }</Label_s>: <span>{ codeFor(_.find(props.inflationData, { inflationid: props.data['lineitemdetail'].inflation.inflationNamedItemId })) }</span>
        </div> }
        { props.data['lineitemdetail']?.['areaMeasureNamedItemId'] && <div>
          <Label_s>{ props.config[state].single[1].label }</Label_s>: <span>{ codeFor(_.find(props.areaMeasureData, { areaid: props.data['lineitemdetail']['areaMeasureNamedItemId'] })) }</span>
        </div> }
        { props.data['adrdetail']?.inflation && <div>
          <Label_s>{ props.config[state].single?.[0].label }</Label_s>: <span>{ codeFor(_.find(props.inflationData, { inflationid: props.data['adrdetail'].inflation.inflationNamedItemId })) }</span>
        </div> }
      </div>
      <div>
        <Label_s></Label_s>
        { items.map((item, i) => {
          return (
            getYearHeader(item['year'])
          )
        })}
      </div>
      <LineItemDetailed_s>
        <div>
          {/* { getMonthNames() } */}
          <Label_s>{ (state === 'detailedPercentLineItem' || state === 'detailedMo') ? 'Average' : 'Total' }</Label_s>
        </div>
        <div>
          { items.map(item => {
            let vals:number[] = Object.values(item);
            vals.pop();
            let total = 0;
            return ( <div>
              { vals.map((val:number, i:number) => {
                total += val;
              }) }
              { (state === 'detailedPercentLineItem' || state === 'detailedMo') ? `${getNumForDisplay(total / vals.length)}` : isValidNumber(total) && localizeNum(total) }
            </div> )
          })}
        </div>
      </LineItemDetailed_s>
      { count > 3 && <div style={{marginLeft: 'auto', padding: '0 15px 15px 0', textAlign: 'right'}}><strong>...</strong></div> }
    </LineItemDetailedHover_s>
  )
}

export default LineItemDetailedHover